import combineStyles from 'components/Templates/general/combineStyles';

import {
  wrapperStyles,
  galleryImagesStyles
} from 'components/Templates/commonStyles/DefaultCssValues';

import {
  sectionWrapperStyles,
  sectionWrapperTabletStyles,
  sectionWrapperMobileStyles,
  wrapperWithMarginStyles,
  wrapperWithMarginTabletStyles,
  galleryRoundTilesStyles,
  typoHeader,
  typoHeaderMobile,
  typoParagraph,
} from 'components/Templates/styles/Red/commonObjectsStyles';

import ButtonMain from 'components/Templates/components/common/buttons/buttonMain';
import ButtonSecondary from 'components/Templates/components/common/buttons/buttonSecondary';
import ButtonSecondaryHidden from 'components/Templates/components/common/buttons/buttonSecondaryHidden';

const buttonStyles = [ButtonMain, ButtonSecondary, ButtonSecondaryHidden];


/* eslint-disable */
const thisStyle = {
  wrapper: {
    '0': {
      ...wrapperStyles,
      ...sectionWrapperStyles,
      'background-color' : '{backgroundColor}'
    },
    '76_8' : {
      ...sectionWrapperTabletStyles
    },
    '37_5' : {
      ...sectionWrapperMobileStyles
    }
  },
  wrapperWithMargin: {
    '0': {
      ...wrapperWithMarginStyles
    },
    '76_8' : {
      ...wrapperWithMarginTabletStyles
    }
  },
  sectionTitle: {
    '0': {
      ...typoHeader,
    },
    '76_8' : {
      ...typoHeaderMobile,
    },
  },
  paragraph: {
    '0': {
      ...typoParagraph,
      'margin-bottom' : '15rem',
      'width': '40%',
    },
    '76_8' : {
      'width': '100%',
      'margin-bottom' : '3rem'
    }
  },
  testimonialsWrapper: {
    '0': {
      'display' : 'flex',
      'justify-content' : 'space-between',
      'margin-top' : '5rem',
      'width': '100%',
    },
    '76_8' : {
      'justify-content' : 'center',
      'flex-direction' : 'column'
    }
  },
  testimonialWrapper: {
    '0': {
      'width': '32%',
      'height': '100%',
      'background-color': '{sectionBackgroundColor}'
    },
    '76_8' : {
      'width': '100%',
      'margin-bottom': '5rem'
    },
  },
  testimonialMark: {
    '0': {
      'font-family': '{mainFont}',
      'font-size': '4.8rem',
      'color': '{primaryColor}',
      'margin-top': '3rem',
      'margin-left': '3rem',
      'margin-right': '3rem',
      'position': 'relative',
      'top': '2rem',
    }
  },
  testimonialOne: {
    '0': {
      ...galleryImagesStyles,
      ...galleryRoundTilesStyles,
      'display': 'flex',
      'height': 'unset',
      'min-height': '20rem',
      'font-size': '1.8rem',
      'line-height': '1.5',
      'align-items': 'center',
      'padding-top': '1rem',
      'padding-bottom': '3rem',
      'padding-left': '3rem',
      'padding-right': '3rem',
      'line-height': '1.3',
    },
    '76_8' : {
      'line-height': '1.5'
    },

  },
  testimonialOneDescriptionWrapper: {
    '0': {
      'display': 'flex',
    },
    '37_5' : {
      'flex-direction': 'column-reverse',
    },
  },
  testimonialOneAuthorTextWrapper: {
    '0': {
      'display' : 'flex',
      'flex-direction' : 'column',
      'justify-content' : 'center',
      'align-items' : 'flex-start',
      'width' : '50%',
      'min-height' : '50%',
      'padding-left' : '3rem',
      'padding-right' : '3rem',
      'padding-bottom' : '3rem',
    },
    '37_5' : {
      'padding-left' : '3rem',
      'padding-right' : '3rem',
      'width' : '100%',
    },
  },
  testimonialOneLogo: {
    '0': {
      'width': '50%',
      'max-width': '15rem',
      'aspect-ratio': '2',
      'background-size': 'contain',
      'background-repeat': 'no-repeat',
      'background-position-y': 'center',
    },
  },
  testimonialOneAuthor: {
    '0': {
      'font-size': '1.8rem',
      'margin-top': '0.5rem',
      'color': '{textColor}',
    },
  },
  testimonialOneCompany: {
    '0': {
      'font-size': '1.8rem',
      'margin-top': '0.5rem',
      'color': '{secondaryTextColor}',
    },
  },
  testimonialOneAuthorAvatar: {
    '0': {
      'display': 'block',
      'width': '50%',
      'aspect-ratio': '1',
      'max-height': '50%',
      'background-size': 'cover',
      'margin-top': 'auto'
    },
    '37_5' : {
      'width': '60%',
      'margin-left': '3rem',
      'margin-bottom': '3rem'
    }
  },
  testimonialTwo: {
    '0': {
      ...galleryImagesStyles,
      ...galleryRoundTilesStyles,
      'display': 'flex',
      'height': 'unset',
      'min-height': '20rem',
      'font-size': '1.8rem',
      'line-height': '1.5',
      'align-items': 'center',
      'padding-top': '1rem',
      'padding-bottom': '3rem',
      'padding-left': '3rem',
      'padding-right': '3rem',
      'line-height': '1.3',
    },
    '76_8' : {
      'line-height': '1.5'
    },

  },
  testimonialTwoDescriptionWrapper: {
    '0': {
      'display': 'flex',
    },
    '37_5' : {
      'flex-direction': 'column-reverse',
    },
  },
  testimonialTwoAuthorTextWrapper: {
    '0': {
      'display' : 'flex',
      'flex-direction' : 'column',
      'justify-content' : 'center',
      'align-items' : 'flex-start',
      'width' : '50%',
      'min-height' : '50%',
      'padding-left' : '3rem',
      'padding-right' : '3rem',
      'padding-bottom' : '3rem',
    },
    '37_5' : {
      'padding-left' : '3rem',
      'padding-right' : '3rem',
      'width' : '100%',
    },
  },
  testimonialTwoLogo: {
    '0': {
      'width': '50%',
      'max-width': '15rem',
      'aspect-ratio': '2',
      'background-size': 'contain',
      'background-repeat': 'no-repeat',
      'background-position-y': 'center',
    },
  },
  testimonialTwoAuthor: {
    '0': {
      'font-size': '1.8rem',
      'margin-top': '0.5rem',
      'color': '{textColor}',
    },
  },
  testimonialTwoCompany: {
    '0': {
      'font-size': '1.8rem',
      'margin-top': '0.5rem',
      'color': '{secondaryTextColor}',
    },
  },
  testimonialTwoAuthorAvatar: {
    '0': {
      'display': 'block',
      'width': '50%',
      'aspect-ratio': '1',
      'max-height': '50%',
      'background-size': 'cover',
      'margin-top': 'auto'
    },
    '37_5' : {
      'width': '60%',
      'margin-left': '3rem',
      'margin-bottom': '3rem'
    }
  },
  testimonialThree: {
    '0': {
      ...galleryImagesStyles,
      ...galleryRoundTilesStyles,
      'display': 'flex',
      'height': 'unset',
      'min-height': '20rem',
      'font-size': '1.8rem',
      'line-height': '1.5',
      'align-items': 'center',
      'padding-top': '1rem',
      'padding-bottom': '3rem',
      'padding-left': '3rem',
      'padding-right': '3rem',
      'line-height': '1.3',
    },
    '76_8' : {
      'line-height': '1.5'
    },

  },
  testimonialThreeDescriptionWrapper: {
    '0': {
      'display': 'flex',
    },
    '37_5' : {
      'flex-direction': 'column-reverse',
    },
  },
  testimonialThreeAuthorTextWrapper: {
    '0': {
      'display' : 'flex',
      'flex-direction' : 'column',
      'justify-content' : 'center',
      'align-items' : 'flex-start',
      'width' : '50%',
      'min-height' : '50%',
      'padding-left' : '3rem',
      'padding-right' : '3rem',
      'padding-bottom' : '3rem',
    },
    '37_5' : {
      'padding-left' : '3rem',
      'padding-right' : '3rem',
      'width' : '100%',
    },
  },
  testimonialThreeLogo: {
    '0': {
      'width': '50%',
      'max-width': '15rem',
      'aspect-ratio': '2',
      'background-size': 'contain',
      'background-repeat': 'no-repeat',
      'background-position-y': 'center',
    },
  },
  testimonialThreeAuthor: {
    '0': {
      'font-size': '1.8rem',
      'margin-top': '0.5rem',
      'color': '{textColor}',
    },
  },
  testimonialThreeCompany: {
    '0': {
      'font-size': '1.8rem',
      'margin-top': '0.5rem',
      'color': '{secondaryTextColor}',
    },
  },
  testimonialThreeAuthorAvatar: {
    '0': {
      'display': 'block',
      'width': '50%',
      'aspect-ratio': '1',
      'max-height': '50%',
      'background-size': 'cover',
      'margin-top': 'auto'
    },
    '37_5' : {
      'width': '60%',
      'margin-left': '3rem',
      'margin-bottom': '3rem'
    }
  },
};

export default combineStyles(thisStyle, buttonStyles);
